window.hideElement = (element) => {
    document.getElementById(element).classList.add('d-none');
}

window.showElement = (element) => {
    document.getElementById(element).classList.remove('d-none');   
}

window.setContents = (element, content) => {
    document.getElementById(element).innerHTML = content;
}

window.appendContents = (element, content) => {
    document.getElementById(element).innerHTML += content;
}

window.writeNumberWithZero = (number)  =>{
    if (number <= 9) {
        return '0' + number;
    } else {
        return number;
    }
}

window.Handlebars = require('handlebars');

Handlebars.registerHelper("formatDate", function (datetime) {
    var date = new Date(Date.parse(datetime));
    var txOffset = date.getTimezoneOffset();
    date.setMinutes(date.getMinutes() + (txOffset));
    return writeNumberWithZero(date.getDate()) + "-" + writeNumberWithZero(date.getMonth()+1) + "-" + date.getFullYear();
});

